// @ts-nocheck
/* eslint-disable react/prop-types */
import {
  Box,
  Button,
  Modal,
  Typography,
  Divider,
  useMediaQuery,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import theme from "../../../theme";
import {
  CustomButton,
  SecondaryButton,
} from "../../../components/Custom/CustomButton";
import PropTypes from "prop-types";

import WestIcon from "@mui/icons-material/West";

import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import { alertDialogAciton } from "../../../store/actions/auth";
import { apiRequest } from "../../../services/apiService";
import LoadingOverlay from "../../../components/Custom/LoadingOverlay";
import {
  applyOpportunityAction,
  clearContractorAppliedListAction,
  declineOpportunityAnywayAction,
  updateResponseAnyway,
} from "../../../store/actions/opportunities";
import {
  convertFromUTCToGivenTimezone,
  formatAMPM,
} from "../../../utils/methods/dateAndTimeMethods";
import { clearScheduleDataAction } from "../../../store/actions/contractorScheduleTabActions";
import { phoneNumberFormat } from "../../../utils/methods/formatters";
import { dateRegex } from "../../../utils/constants/dateRegex";
import { getUniversalDateTimeFormat } from "../../../utils/methods/universalDateTimeFormat";
import { AlertDialogForSendOpportunity } from "../../../components/Custom/AlertDialog";
import { CustomSwitch } from "../../../components/Custom/Switch";

export function generateDateTableForDecline(data) {
  if (!data) return null;

  const border = getCssVariableHandler({ variableName: "--primary-pink-hex" });

  let html = `
            <h4 style="color: white; text-align: left; margin-top: 0px; font-weight:400;">${data?.[0]?.message ?? "No Title"}</h4>
            <table style="border-collapse: collapse; width: 100%; text-align: center; color: white; margin-bottom: 20px;">
                <thead>
                    <tr>
                        <th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Position Name</th>
                        <th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Date</th>
                    </tr>
                </thead>
                <tbody>
        `;

  data?.forEach((value) => {
    html += `
                <tr>
                    <td style="border: 1px solid ${border}; padding: 5px;">${value?.positionName} ${value?.positionOrder ? `-${value?.positionOrder}` : ""}</td>
                    <td style="border: 1px solid ${border}; padding: 5px;">${value?.Date ?? "N/A"}</td>
                </tr>
            `;
  });

  html += `</tbody></table>`;

  return html || null;
}

function ViewOpportunitiesModal({
  open,
  setOpen,
  selectedRow,
  showButtons = true,
  opportunityId,
  id,
  data: rowData,
  setCount,
}) {
  const initialAlertData = useMemo(
    () => ({
      status: false,
      message: null,
      title: null,
      onOk: null,
      okLabel: null,
      isLoading: false,
    }),
    [],
  );

  // media query hooks...
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  // media query hooks...

  const dispatch = useDispatch();
  const [data, setData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [contractorStatus, setContractorStatus] =
    React.useState("not responded");
  const { oppLoading: loading } = useSelector((state) => state.opportunities);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [alertData, setAlertData] = useState(initialAlertData);

  React.useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const { response, error } = await apiRequest({
        method: "GET",
        url: "getOpportunityById",
        params: {
          id,
          opportunityId,
        },
        isToken: true,
      });
      if (response?.status === 200) {
        setData(response?.data?.data);
        setIsLoading(false);
      } else if (response?.status !== 200 || error) {
        setData(null);
        setIsLoading(false);
        dispatch(
          alertDialogAciton({
            open: true,
            title: "Error",
            message:
              error?.response?.data?.message || "Fail to get opportunity!",
          }),
        );
        handleClose();
      }
    };

    fetchData();
  }, []);

  React.useEffect(() => {
    if (data?.applied) {
      setContractorStatus("Applied");
    } else if (data?.declined) {
      setContractorStatus("Declined");
    }
  }, [data]);

  const handleClose = () => {
    setOpen(false);
  };

  const getColorOfStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "#4D4D4D";
      case "not responded":
        return "#4D4D4D";
      case "applied":
        return "#02493E";
      case "declined":
        return "#371414";

      default:
        return "white";
    }
  };

  const getTextColorOfStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "black";
      case "not responded":
        return "white";
      case "applied":
        return "#07EEC5";
      case "declined":
        return "#FF4B4B";

      default:
        return "black";
    }
  };

  const handleAcceptClick = () => {
    dispatch(
      applyOpportunityAction({
        payload: {
          data: {
            response: "applied",
          },
          id: opportunityId,
          params: {
            positionId: data?.positionId,
            sessionId: data?.sessionId,
            Id: opportunityId,
          },
        },
        successCallback: (rdata) => {
          if (!rdata?.scheduledConflictContractors?.length) {
            dispatch(
              alertDialogAciton({
                title: "Success",
                message: "Opportunity accepted successfully!",
                open: true,
              }),
            );
            dispatch(clearContractorAppliedListAction());
            dispatch(clearScheduleDataAction());
            setOpen(false);
            setCount((prev) => prev + 1);
          } else {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Conflict Alert",
                message: "You have a schedule conflict with this opportunity!",
                onOk: () => {
                  dispatch(
                    updateResponseAnyway({
                      payload: {
                        data: {
                          response: "applied",
                        },
                        id: opportunityId,
                        params: {
                          positionId: data?.positionId,
                          sessionId: data?.sessionId,
                          Id: opportunityId,
                        },
                      },
                      successCallback: () => {
                        dispatch(
                          alertDialogAciton({
                            title: "Success",
                            message: "Opportunity accepted successfully!",
                            open: true,
                          }),
                        );
                        dispatch(clearContractorAppliedListAction());
                        dispatch(clearScheduleDataAction());
                        setOpen(false);
                        setCount((prev) => prev + 1);
                      },
                      failureCallback: (msg) => {
                        dispatch(
                          alertDialogAciton({
                            title: "Error",
                            message: msg || "Fail to accept opportunity!",
                            open: true,
                          }),
                        );
                      },
                    }),
                  );
                },
                okLabel: "Accept Anyway",
              }),
            );
          }
        },
        failureCallback: (msg) => {
          dispatch(
            alertDialogAciton({
              title: "Error",
              message: msg?.message || "Fail to accept opportunity!",
              open: true,
            }),
          );
        },
      }),
    );
  };

  const handleDeclineClick = () => {
    dispatch(
      applyOpportunityAction({
        payload: {
          data: {
            response: "declined",
          },
          id: opportunityId,
          params: {
            positionId: data?.positionId,
            sessionId: data?.sessionId,
            Id: opportunityId,
          },
        },
        successCallback: (d) => {
          let checkBoxStatus = false;
          if (d?.lastOpportunity) {
            setAlertData({
              status: true,
              message: (
                <Box>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: generateDateTableForDecline(d?.lastOpportunity),
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    {/* <Checkbox */}
                    {/*   sx={{ */}
                    {/*     padding: 0, */}
                    {/*     color: "white", */}
                    {/*   }} */}
                    {/*   onChange={(e) => (checkBoxStatus = e?.target?.checked)} */}
                    {/* /> */}
                    <CustomSwitch
                      onChange={(e) => (checkBoxStatus = e?.target?.checked)}
                    />
                    <Typography>
                      Apply hold down shift for above date
                    </Typography>
                  </Box>
                </Box>
              ),
              title: "Alert",
              onOk: () => {
                // NOTE: decline anyway
                handleDeclineAnyWayClick(checkBoxStatus);
              },
              okLabel: "Proceed",
              isLoading: false,
            });
          } else {
            dispatch(
              alertDialogAciton({
                title: "Success",
                message: "Opportunity denied successfully!",
                open: true,
              }),
            );
            setOpen(false);
            setCount((prev) => prev + 1);
          }
        },
        failureCallback: () => {
          dispatch(
            alertDialogAciton({
              title: "Error",
              message: "Fail to decilne opportunity!",
              open: true,
            }),
          );
        },
      }),
    );
  };

  const handleDeclineAnyWayClick = (status) => {
    setAlertData((prev) => ({ ...prev, isLoading: true }));

    function stopLoadin() {
      setAlertData((prev) => ({ ...prev, isLoading: false }));
    }
    dispatch(
      declineOpportunityAnywayAction({
        payload: {
          params: {
            eventId: rowData?.eventId,
          },
          data: {
            positionIds: [
              {
                sessionId: data?.sessionId,
                id: data?.positionId,
                holdDown: status,
              },
            ],
          },
        },
        successCallback: (d) => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Success",
              message: d?.message ?? "Opportunity successfully declined",
            }),
          );
          setOpen(false);
          setCount((prev) => prev + 1);
          stopLoadin();
        },
        failureCallback: (msg) => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Failure",
              message: msg ?? "Fail to decline opportunity",
            }),
          );
          stopLoadin();
        },
      }),
    );
  };

  return (
    <Modal
      // className="modelBox"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "relative",
          // top: "50%",
          // left: "50%",
          // transform: "translate(-50%, -50%)",
          width: isMediumScreen ? "95%" : "60%",
          // minWidth: "880px",
          minHeight: isLoading ? "60%" : "50%",
          height: "auto",
          maxHeight: "95%",
          maxWidth: "1080px",
          // minHeight: "500px",
          boxShadow: 24,
          p: 4,
          borderRadius: "16px",
          padding: "40px",
          gap: "30px",
          border: "2px solid #D175B6",
          backgroundColor: "#000",
          display: "flex",
          flexDirection: "column",
          zIndex: 9,
          overflowY: "auto",
          "@media (max-width: 600px)": {
            minWidth: "0px",
            width: "97vw",
            maxHeight: "95vh",
            overflowY: "auto",
          },
        }}
        className="custom-scroll-design"
      >
        {(isLoading || loading) && (
          <LoadingOverlay open={isLoading || loading} />
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Button
            onClick={() => setOpen(false)}
            sx={{
              minWidth: "0",
              height: "auto",
              background: "none",
              padding: isSmallScreen ? "0" : "0.5rem",
              boxShadow: "none",
              border: isSmallScreen
                ? "none"
                : `1px solid ${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })}`,
              zIndex: "10",
              borderRadius: "50%",
              cursor: "pointer !important",
              "&:hover": {
                minWidth: "0",
                background: "none",
                padding: isSmallScreen ? "0" : "0.5rem",
                boxShadow: "none",
                border: isSmallScreen
                  ? "none"
                  : `1px solid ${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })}`,
                borderRadius: "50%",
              },
            }}
          >
            <WestIcon />
          </Button>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            marginBottom="20px"
            sx={{
              float: "left",
              margin: "0 auto",
              fontSize: "32px",
              zIndex: "10",
            }}
          >
            View Opportunities
          </Typography>
        </Box>
        {!isLoading ? (
          <>
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  border: "1px solid rgba(255,255,255,0.3)",
                  width: "100%",
                  height: "auto",
                  padding: "10px",
                  gap: "5px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  zIndex: "10",
                }}
              >
                <Typography sx={{ fontSize: "20px" }}>
                  Event Name: {data?.eventName}
                </Typography>

                <Typography sx={{ fontSize: "17px" }}>
                  Session: {data?.sessionName}
                </Typography>
                {/* <Typography sx={{ fontSize: "14px" }}>
                Client: {data?.clientName}
              </Typography> */}
                {data?.coordinators?.length > 0 && (
                  <Typography sx={{ fontSize: "14px", textWrap: "wrap" }}>
                    Coordinator{data?.coordinators?.length > 1 ? "s" : ""}:{" "}
                    {data?.coordinators
                      ?.map(
                        (item) =>
                          `${item?.name} - (${phoneNumberFormat(item?.mobile)})`,
                      )
                      .join(", ")}
                  </Typography>
                )}
              </Box>
              {data?.adminMessage && (
                <Box
                  sx={{
                    width: "100%",
                    textAlign: "center",
                    mt: "0.5rem",
                  }}
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    Admin Message: {data?.adminMessage}
                  </Typography>
                </Box>
              )}
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                backgroundColor: "#64646466",
                padding: "0.5rem 1rem",
                borderRadius: "0.5rem",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                }}
              >
                <Typography
                  sx={{
                    color: getCssVariableHandler({
                      variableName: "--primary-green-text-rgb",
                    }),
                  }}
                >
                  Position Name :
                </Typography>
                <Typography sx={{ color: "white" }}>
                  {data?.positionName}{" "}
                  {typeof data?.numberOfHours === "number" &&
                  data?.numberOfHours > 0
                    ? `(TBD ${data?.numberOfHours} hours)`
                    : ""}
                </Typography>
              </Box>

              <Typography
                sx={{
                  color: getTextColorOfStatus(contractorStatus),
                  border: `1px solid ${getColorOfStatus(contractorStatus)}`,
                  backgroundColor: getColorOfStatus(contractorStatus),
                  padding: "0.2rem",
                  borderRadius: "8px",
                  minWidth: "23%",
                  textAlign: "center",
                  height: "35px",
                  textTransform: "capitalize",
                }}
              >
                {contractorStatus}
              </Typography>
            </Box>

            <Box
              sx={{
                border: `1px solid ${theme.palette.secondary.main}`,
                width: "100%",
                borderRadius: "3px",
                height: "auto",
                padding: "10px",
                gap: "10px",
                display: "flex",
                flexDirection: "column",
                fontSize: "14px",
                zIndex: "10",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  zIndex: "10",
                  "& p": {
                    width: "50%",
                  },
                }}
              >
                <Typography
                  sx={{
                    margin: "0 auto",
                  }}
                >
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    Date Start:{" "}
                  </span>
                  {getUniversalDateTimeFormat({ dateTime: data?.startDate })}
                </Typography>

                <Typography
                  sx={{
                    margin: "0 auto",
                  }}
                >
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    Overnight Shift:{" "}
                  </span>
                  {data?.overNightShift ? "Yes" : "No"}
                </Typography>
              </Box>
              <Divider
                sx={{
                  width: "100%",
                  border: `1px solid ${theme.palette.secondary.main}`,
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  zIndex: "10",
                  "& p": {
                    width: "50%",
                  },
                }}
              >
                <Typography>
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    {" "}
                    Time In:{"  "}
                  </span>
                  {/* {data?.timeIn} */}
                  {dateRegex.test(data?.timeIn?.split?.("T")?.[0])
                    ? formatAMPM(
                        convertFromUTCToGivenTimezone({
                          dateStr: data?.timeIn,
                          timezone: data?.timezone,
                        }),
                      )
                    : "TBD"}
                </Typography>
                <Typography
                  sx={{
                    margin: "0 auto",
                  }}
                >
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    Time End:{"  "}
                  </span>
                  {/* {data?.timeOut} */}
                  {dateRegex.test(data?.timeOut?.split?.("T")?.[0])
                    ? formatAMPM(
                        convertFromUTCToGivenTimezone({
                          dateStr: data?.timeOut,
                          timezone: data?.timezone,
                        }),
                      )
                    : "TBD"}
                </Typography>
              </Box>
              <Divider
                sx={{
                  width: "100%",
                  border: `1px solid ${theme.palette.secondary.main}`,
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  "& p": {
                    width: "50%",
                  },
                }}
              >
                <Typography>
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    Complexity:{"  "}
                  </span>
                  {data?.complexity}
                </Typography>
                <Typography
                  sx={{
                    margin: "0 28%",
                  }}
                >
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    Attire:{"  "}
                  </span>
                  {data?.attire}
                </Typography>
              </Box>
              <Divider
                sx={{
                  width: "100%",
                  border: `1px solid ${theme.palette.secondary.main}`,
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Typography>
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    {" "}
                    Meal Option:{"  "}
                  </span>
                  {data?.info}
                </Typography>
              </Box>
              <Divider
                sx={{
                  width: "100%",
                  border: `1px solid ${theme.palette.secondary.main}`,
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Typography>
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    {" "}
                    Comments:{"  "}
                  </span>
                  {data?.comments}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                backgroundColor: `${theme.palette.secondary.main}`,
                width: "100%",
                borderRadius: "3px",
                height: "auto",
                padding: "10px",
                gap: "5px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "14px",
              }}
            >
              <Box
                sx={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: "0.5",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: -1,
                  }}
                />
                <Box
                  sx={{
                    position: "relative",
                    zIndex: "10",
                    color: "rgba(245,245,245,1) !important",
                  }}
                >
                  {/* <Typography>Churchill Downs</Typography> */}
                  <Typography>{data?.location}</Typography>
                  <Typography>{` ${rowData?.venue}, ${rowData?.venueAddressLine1}, ${rowData?.venueCity}, ${rowData?.venueState}, ${rowData?.venueZipCode}`}</Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: "10",
                }}
              >
                <iframe
                  width="100%"
                  height="100%"
                  loading="lazy"
                  allowfullscreen
                  src={`https://www.google.com/maps/embed/v1/place?key=${import.meta.env.VITE_GOOGLE_API_KEY}${
                    data?.lat && data?.long
                      ? `&center=${data.lat},${data.long}`
                      : ""
                  }&q=${encodeURIComponent(
                    [
                      rowData?.venue,
                      rowData?.venueAddressLine1,
                      rowData?.venueCity,
                      rowData?.venueState,
                      rowData?.venueZipCode,
                    ]
                      .filter(Boolean) // Remove falsy values
                      .join(", "), // Combine valid parts with a comma and space
                  )}`}
                ></iframe>
              </Box>
            </Box>
            {showButtons && data?.pending && (
              <Box
                sx={{
                  width: "50%",
                  height: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  margin: "0 auto",
                }}
              >
                <CustomButton onClick={handleAcceptClick}>
                  <Typography sx={{ fontSize: "1.5rem" }}>Accept</Typography>
                </CustomButton>
                <SecondaryButton onClick={handleDeclineClick}>
                  <Typography sx={{ fontSize: "1.5rem" }}>Decline</Typography>
                </SecondaryButton>
              </Box>
            )}
          </>
        ) : null}

        {alertData?.status && (
          <AlertDialogForSendOpportunity
            open={alertData?.status}
            message={alertData?.message}
            title={alertData?.title}
            onOk={alertData?.onOk}
            okLabel={alertData?.okLabel}
            handleClose={() => setAlertData(initialAlertData)}
            isLoading={alertData?.isLoading}
          />
        )}
      </Box>
    </Modal>
  );
}

export default ViewOpportunitiesModal;

ViewOpportunitiesModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  selectedRow: PropTypes.object,
  showButtons: PropTypes.bool,
  opportunityId: PropTypes.string,
  id: PropTypes.string,
  data: PropTypes.object,
  setCount: PropTypes.func,
};
